import { observer } from 'mobx-react-lite'
import React from 'react'
import { Icon, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type Integration } from 'entities/Integrations/model/Integration'
import { getIntegrationDetailsDataByKey } from 'entities/Integrations/lib/integrationsDescription'
import { IntegrationStatus } from 'widgets/IntegrationStatus'
import { IntegrationListCardActions } from 'pages/settings/pages/integrations/pages/integrationList/ui/IntegrationListCard/IntegrationListCardActions'
import { SettingsRoutes } from 'pages/settings/route/type'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import styles from './styles.module.scss'

type IIntegrationListCardProps = {
  integration: Integration
}

export const IntegrationListCard = observer(({ integration }: IIntegrationListCardProps) => {
  const integrationData = getIntegrationDetailsDataByKey(integration.key)

  const onCardClick = () => {
    uiStore.changeRoute({
      path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${integration.key}`,
    })
  }

  return (
    <>
      <div className={styles.card} onClick={onCardClick}>
        <div className={styles.cardHeader}>
          <Icon icon={integration.icon} fontSize={26} />
          <div className={styles.cardHeaderRight}>
            <IntegrationStatus integration={integration} />
            {integration.isConnected && !integration.loading && (
              <IntegrationListCardActions integration={integration} />
            )}
            {integration.loading && <SpinnerLoader ariaLabel={'integrationLoader'} size={20} />}
          </div>
        </div>
        <div className={styles.data}>
          <Typography variant='body-md-medium' ariaLabel={'Integration_name'}>
            {integration.name}
          </Typography>
          <Typography
            variant='body-md-regular'
            ariaLabel={'Integration_subheadline'}
            color='tertiary'
            className={styles.subheadline}
          >
            {integrationData?.subheadline}
          </Typography>
        </div>
      </div>
    </>
  )
})
